export const finalizacoesStatus = {
    CRIADO: 0,
    EM_APROVACAO: 1,
    EM_APROVACAO_PELO_GERENTE: 2,
    EM_APROVACAO_PELO_ASSESSOR_DARF: 3,
    EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO: 4,
    REPROVADA: 5,
    REPROVADA_PELO_GERRENTE: 6,
    REPROVADA_PELO_ASSESSOR_DARF: 7,
    REPROVADA_PELO_SETOR_FINANCEIRO: 8,
    CONCLUIDA: 9,
    CANCELADO: 10,
    EXCLUIDO: 11,
    AGUARDANDO_SETOR_FINANCEIRO: 12
}